// utils/ownUnit.js
//
// Staff, Technician and Manager always raise tasks/complaints for their
// OWN unit. Mirrors the backend's OWN_UNIT_TASK_ROLES
// (services/unitBoundRoleService.js#resolveTaskCreateUnitId), which is the
// real control: a different unit_id is rejected with 403 there. The form
// shows the unit read-only, from the session user that AuthContext re-syncs
// from GET /auth/me (unit_id / unit_name), never a picker over every unit.
export const OWN_UNIT_TASK_ROLES = new Set(["manager", "staff", "technician"]);

export const isOwnUnitTaskCreator = (user) =>
  OWN_UNIT_TASK_ROLES.has(String(user?.role || user?.role_name || "").trim().toLowerCase());

export const ownUnitId = (user) => (user?.unit_id ? String(user.unit_id) : "");

// Name of the user's own unit: /auth/me's unit_name, else the matching row
// of an already-loaded unit list (an older backend without unit_name).
export const ownUnitName = (user, units = []) => {
  if (user?.unit_name) return user.unit_name;
  const id = ownUnitId(user);
  const row = id ? units.find((u) => String(u?.id) === id) : null;
  return row?.name || "";
};
